document.addEventListener('DOMContentLoaded', function() {
    var page = 1;
    var category = 'learning-center'; // Default category

    function loadPosts(reset = false) {
        if(reset){
            page = 1;
        }else{
            page++;
        }
        const xhr = new XMLHttpRequest();
        xhr.open('POST', my_ajax_obj.ajax_url, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 400) {
                const response = xhr.responseText;
                if (reset) {
                    document.getElementById('posts-container').innerHTML = response;
                    document.getElementById('load-more-btn').style.display = 'block';
                } else {
                    if (response) {
                        document.getElementById('posts-container').insertAdjacentHTML('beforeend', response);
                    } else {
                        // No more posts to load
                        document.getElementById('load-more-btn').style.display = 'none';
                    }
                }
            }
        };
        xhr.send('action=load_more_posts&page=' + page + '&category=' + category);
    }

    document.getElementById('load-more-btn').addEventListener('click', function(e) {
        e.preventDefault();
        loadPosts(false);
    });

    if(document.querySelector('.category-select')){
        document.querySelectorAll('.category-select').forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                category = this.getAttribute('data-category');
                loadPosts(true);
            });
        });
    }

    // Load initial posts
    loadPosts(true);
});
